import React, { useState, useEffect } from 'react';
import { Search, Calendar, ExternalLink, Play, ArrowRight, Filter, Grid, List } from 'lucide-react';

const BlogPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [viewMode, setViewMode] = useState('grid');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [isLoading, setIsLoading] = useState(true);

  const blogs = [
    {
      title: "From Haldi to Reception: Complete Wedding Decoration Services in Gaya",
      description: "At Aryan Events, we understand the emotional and cultural significance of each event. That's why our team provides complete wedding decoration services in Gaya, offering...",
      date: "Apr 11, 2025",
      image: "/assets/vlogpicture2.jpg",
      slug: "anniversary-decoration-ideas",
      url: "https://youtu.be/pHl_MjgPiZo?si=B_aybdVlQMg7prRH",
      externalUrl: "https://medium.com/@aryaneventindia/from-haldi-to-reception-complete-wedding-decoration-services-in-gaya-025f7b4e5bf6",
      category: "wedding",
      readTime: "5 min read"
    },
    {
      title: "Best Wedding Planner Service in Gaya, Bihar",
      description: "We offer a complete range of event planning services, tailored to fit your vision and budget. Our team ...",
      date: "May 19, 2025",
      image: "/assets/vlogpicture1.jpg",
      slug: "anniversary-decoration-ideas",
      url: "https://youtu.be/pHl_MjgPiZo?si=B_aybdVlQMg7prRH",
      externalUrl: "https://medium.com/@aryaneventindia/best-wedding-planner-service-in-gaya-ji-bihar-61bc8c9c0c48",
      category: "wedding",
      readTime: "4 min read"
    },
    {
      title: "Top Event Management Company in Bihar",
      description: "At Aryan Events, we don't just organize events; we curate unforgettable moments that leave lasting impressions...",
      date: "Apr 19, 2025",
      image: "/assets/vlogpicture4.jpg",
      slug: "anniversary-decoration-ideas",
      url: "https://youtu.be/pHl_MjgPiZo?si=B_aybdVlQMg7prRH",
      externalUrl: "https://medium.com/@aryaneventindia/top-event-management-company-in-bihar-0f5d43ad339f",
      category: "corporate",
      readTime: "6 min read"
    },
    {
      title: "Best Anniversary Planner in Bihar",
      description: "Celebrating an anniversary is a special milestone that deserves a well-planned and memorable event...",
      date: "Mar 28,2025",
      image: "/assets/vlogpicture3.jpg",
      slug: "anniversary-decoration-ideas",
      url: "https://youtu.be/pHl_MjgPiZo?si=B_aybdVlQMg7prRH",
      externalUrl: "https://medium.com/@aryaneventindia/best-anniversary-planner-in-bihar-dc19bccdb41a",
      category: "celebration",
      readTime: "3 min read"
    },
    {
      title: "Best Events Management Company in Gaya",
      description: "Planning an event, whether personal or professional, requires precision, creativity, and seamless execution. That's where a top-tier event...",
      date: "March 21,2025",
      image: "/assets/vlogpicture5.jpg",
      slug: "anniversary-decoration-ideas",
      url: "https://youtu.be/pHl_MjgPiZo?si=B_aybdVlQMg7prRH",
      externalUrl: "https://medium.com/@aryaneventindia/best-events-management-company-in-gaya-0dd30cb2863d",
      category: "corporate",
      readTime: "5 min read"
    }
  ];

  const categories = ['all', 'wedding', 'corporate', 'celebration'];

  useEffect(() => {
    // Simulate loading
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    let filtered = blogs;
    
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(blog => blog.category === selectedCategory);
    }
    
    if (searchTerm) {
      filtered = filtered.filter(blog =>
        blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        blog.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    setFilteredBlogs(filtered);
  }, [searchTerm, selectedCategory]);

  const handleBlogClick = (blog) => {
    if (blog.externalUrl) {
      window.open(blog.externalUrl, '_blank');
    }
  };

  const LoadingCard = () => (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden animate-pulse">
      <div className="h-48 bg-gray-300"></div>
      <div className="p-6">
        <div className="h-4 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 bg-gray-300 rounded mb-4 w-3/4"></div>
        <div className="h-3 bg-gray-300 rounded w-1/2"></div>
      </div>
    </div>
  );

  // Function to render grid items with proper centering
  const renderGridItems = () => {
    const items = filteredBlogs.map((blog, index) => (
      <div
        key={blog.title}
        onClick={() => handleBlogClick(blog)}
        className="group cursor-pointer transform transition-all duration-500 hover:scale-[1.02]"
        style={{ animationDelay: `${index * 0.1}s` }}
      >
        <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl overflow-hidden transform transition-all duration-500 hover:shadow-2xl border border-white/20 group-hover:border-blue-200">
          <div className="relative overflow-hidden">
            <img
              className="w-full h-56 object-cover transition-transform duration-700 group-hover:scale-110"
              src={blog.image}
              alt={blog.title}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
              <ExternalLink className="w-4 h-4 text-blue-600" />
            </div>
            <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
              <span className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                {blog.category}
              </span>
            </div>
          </div>
          
          <div className="p-6">
            <h3 className="text-xl font-bold text-gray-800 mb-3 line-clamp-2 group-hover:text-blue-600 transition-colors duration-300">
              {blog.title}
            </h3>
            <p className="text-gray-600 mb-4 line-clamp-3 leading-relaxed">
              {blog.description}
            </p>
            
            <div className="flex items-center justify-between text-sm text-gray-500">
              <div className="flex items-center gap-2">
                <Calendar className="w-4 h-4" />
                <span>{blog.date}</span>
              </div>
              <span className="text-blue-500 font-medium">{blog.readTime}</span>
            </div>
            
            <div className="mt-4 flex items-center text-blue-500 font-semibold group-hover:text-blue-600 transition-colors duration-300">
              <span>Read More</span>
              <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" />
            </div>
          </div>
        </div>
      </div>
    ));

    // If we have exactly 5 items, we want to center the last 2
    if (items.length === 5) {
      return (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 mb-8">
            {items.slice(0, 3)}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {items.slice(3, 5)}
          </div>
        </>
      );
    }
    
    // For other numbers of items, use regular grid
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
        {items}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      {/* Hero Section */}
  <div className="relative overflow-hidden bg-slate-800">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20"></div>
        
        {/* Animated background elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-gradient-to-r from-blue-400 to-cyan-400 rounded-full opacity-30 animate-bounce"></div>
        <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full opacity-25 animate-pulse"></div>
        
        <div className="relative container mx-auto px-4 py-24 text-center">
          <h1 className="text-7xl md:text-8xl font-black text-white mb-6 tracking-tight">
            OUR <span className="bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">VLOGS</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
            Dive into our world of extraordinary events and unforgettable moments
          </p>
          <div className="flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full"></div>
          </div>
        </div>
      </div>

      {/* Search and Filter Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-xl p-8 mb-12 border border-white/20">
          <div className="flex flex-col lg:flex-row gap-6 items-center justify-between">
            {/* Search Bar */}
            <div className="relative flex-1 max-w-md">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search vlogs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-4 rounded-2xl border-2 border-gray-200 focus:border-blue-500 focus:outline-none transition-all duration-300 bg-white/90 backdrop-blur-sm"
              />
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 ${
                    selectedCategory === category
                      ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                      : 'bg-white/60 text-gray-700 hover:bg-white/80 border border-gray-200'
                  }`}
                >
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </button>
              ))}
            </div>

            {/* View Mode Toggle */}
            <div className="flex bg-gray-100 rounded-2xl p-1">
              <button
                onClick={() => setViewMode('grid')}
                className={`p-3 rounded-xl transition-all duration-300 ${
                  viewMode === 'grid' ? 'bg-white shadow-md text-blue-500' : 'text-gray-400'
                }`}
              >
                <Grid className="w-5 h-5" />
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={`p-3 rounded-xl transition-all duration-300 ${
                  viewMode === 'list' ? 'bg-white shadow-md text-blue-500' : 'text-gray-400'
                }`}
              >
                <List className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Blog Cards */}
        <div>
          {isLoading ? (
            // Loading state
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
              {Array.from({ length: 6 }).map((_, index) => (
                <LoadingCard key={index} />
              ))}
            </div>
          ) : viewMode === 'grid' ? (
            // Grid view with centering logic
            renderGridItems()
          ) : (
            // List view
            <div className="space-y-6">
              {filteredBlogs.map((blog, index) => (
                <div
                  key={blog.title}
                  onClick={() => handleBlogClick(blog)}
                  className="group cursor-pointer transform transition-all duration-500 hover:scale-[1.02] flex bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl overflow-hidden border border-white/20"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="w-72 flex-shrink-0">
                    <div className="relative h-48 overflow-hidden">
                      <img
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        src={blog.image}
                        alt={blog.title}
                      />
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>
                  </div>
                  
                  <div className="flex-1 p-6 flex flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-2 mb-2">
                        <span className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                          {blog.category}
                        </span>
                        <span className="text-gray-500 text-sm">{blog.readTime}</span>
                      </div>
                      
                      <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                        {blog.title}
                      </h3>
                      <p className="text-gray-600 mb-4 leading-relaxed">
                        {blog.description}
                      </p>
                    </div>
                    
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2 text-sm text-gray-500">
                        <Calendar className="w-4 h-4" />
                        <span>{blog.date}</span>
                      </div>
                      
                      <div className="flex items-center text-blue-500 font-semibold group-hover:text-blue-600 transition-colors duration-300">
                        <span>Read More</span>
                        <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* No Results State */}
        {!isLoading && filteredBlogs.length === 0 && (
          <div className="text-center py-16">
            <div className="max-w-md mx-auto">
              <div className="w-24 h-24 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full flex items-center justify-center mx-auto mb-6">
                <Search className="w-12 h-12 text-gray-500" />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2">No vlogs found</h3>
              <p className="text-gray-600 mb-6">Try adjusting your search or filter criteria</p>
              <button
                onClick={() => {
                  setSearchTerm('');
                  setSelectedCategory('all');
                }}
                className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-3 rounded-full font-semibold hover:shadow-lg transition-all duration-300 transform hover:scale-105"
              >
                Clear Filters
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPage;